module.exports = {"name":"youboralib","type":"lib","tech":"js","author":"Jordi Aguilar","version":"6.1.8","built":"2017-12-22","repo":"https://bitbucket.org/npaw/lib-plugin-js.git"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/youboralib/manifest.json
// module id = 120
// module chunks = 0